import { SxProps } from '@mui/material';
import {getTheme} from "app/components/ThemeProvider/theme";

const theme = getTheme('light');

export const secondaryText = {
  fontSize: '16px',
  fontWeight: 400,
  color: '#14191F8F',
};

export const mainText = {
  fontSize: '20px',
  fontWeight: 600,
};
export const iconBox: SxProps = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '48px',
  height: '48px',
  borderRadius: '24px',
};


export const accordionSummary: SxProps = {
  height: '114px',
  padding: '32px 28px',

  '&.Mui-disabled': {
    opacity: 1,
  },

  [theme.breakpoints.down(700)]: {
    padding: '16px 20px',
  },
  [theme.breakpoints.down('lg')]: {
    padding: '20px 18px',
    height: 'auto',
    minHeight: '114px',
    alignItems: 'start',
    '& .MuiAccordionSummary-expandIconWrapper': {
      mt: '12px',
    },
  },
  [theme.breakpoints.down('md')]: {
    alignItems: 'center',
    '& .MuiAccordionSummary-expandIconWrapper': {
      mt: '0px',
    },
  },
  [theme.breakpoints.down(855)]: {
    height: 'auto',
    minHeight: '114px',
    alignItems: 'start',
    '& .MuiAccordionSummary-expandIconWrapper': {
      mt: '12px',
    },
  },
  [theme.breakpoints.down("sm")]: {
    '& .MuiAccordionSummary-expandIconWrapper': {
      position: "absolute",
      right: "5%",
    },
  },
};

export const headerWithBalans: SxProps = {
  display: 'flex',
  gap: '125px',
  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
    gap: '20px'
  },
  [theme.breakpoints.down('md')]: {
    flexDirection: 'row',
    gap: '64px',
  },
  [theme.breakpoints.down(855)]: {
    flexDirection: 'column',
    gap: '20px'
  },
}

export const iconWithSummary: SxProps = {
  display: 'flex', gap: '24px', alignItems: 'center', width: '100%', pr: '28px',
  [theme.breakpoints.down('lg')]: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'normal',
  },
  [theme.breakpoints.down('md')]: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  [theme.breakpoints.down(855)]: {
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'normal',
  },
  [theme.breakpoints.down('sm')]: {
    pr: '0px'
  },
}
export const statusBox: SxProps = {
  display: 'flex', flexDirection: 'row',
  gap: '16px',
  alignItems: 'center',
  justifyContent: 'center',
  mr: '12px',
  [theme.breakpoints.down('lg')]: {
    alignItems: 'start'
  },
  [theme.breakpoints.down('md')]: {
    alignItems: 'center',
  },
  [theme.breakpoints.down(855)]: {
    alignItems: 'start'
  },
  [theme.breakpoints.down("sm")]: {
    position: "absolute",
    right: "10%",
  },
}